export { default } from './Badge';

export { default as badgeClasses } from './badgeClasses';
export * from './badgeClasses';
